import {Navigate, useLocation} from 'react-router-dom';
import {PATH_AUTH} from '../../routes/paths';
import LoadingScreen from '../LoadingScreen';
import {useAuthenticationContext} from '../../contexts/authentication'

export const Private = ({children}) => {
    const {customer, status} = useAuthenticationContext();
    const {pathname, search} = useLocation();

    if (!status.initialized || status.loggingIn || status.loggingOut) {
        return <LoadingScreen/>
    }

    if (!customer.isLoggedIn()) {
        return <Navigate to={PATH_AUTH.login} replace state={{from: pathname, search}}/>
    }

    return <>{children}</>
}

export default Private;
